import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'

const DEBOUNCE_TIMEOUT = 500

export default {
	methods: {
		...mapActions('app', ['cachePageFilters']),
		...mapActions('list', ['getListsMeta']),
		...mapActions('post', ['fetchPosts', 'getPollUsers']),
		...mapActions('event', [
			'fetchEvents',
			'getAttendeesEvent',
			'getAgendaEvent',
			'getBoothStaff',
			'getEventSpeakersById',
			'getActionFiles',
			'getActionLinks',
		]),
		...mapActions('forum', ['fetchForums']),
		...mapActions('forum', ['fetchForumCategories']),
		...mapActions('directory', ['getDirectories', 'getSubDirectories']),
		...mapActions('resources', ['getResources', 'getResourcesById']),
		...mapActions('app', ['setSearch']),

		toggleFilterModalIsVisible() {
			this.filterModalIsVisible = !this.filterModalIsVisible
		},
		handleChipClick(payload) {
			const { name, label } = payload
			this.currentModalFilter = name
			this.currentModalLabel = label

			const initDate = {
				selectedRange: {
					from: null,
					to: null,
				},
				option: null,
				error: '',
			}

			switch (name) {
				case 'clear': {
					const initFilters = {
						page: 1,
						myposts: false,
						category_id: null,
						past: false,
						field: null,
					}
					const needRequest =
						Object.values(this.selectedChips).some((value) => value.length) ||
						!_.isEqual(this.filters1, initFilters) ||
						!_.isEqual(this.date, initDate)
					this.selectedChips = {}
					this.filters = initFilters
					this.date = initDate
					needRequest && this.getFilteredItems()
					break
				}
				case 'scheduled':
				case 'admin':
				case 'users':
				case 'register':
				case 'schedule':
				case 'follow':
				case 'event_follow':
				case 'categories':
				case 'registered': {
					const currentFilters = this.selectedChips.filters
					const filter = this.filterValues.find((filter) => filter.name === name).filter
					if (currentFilters) {
						const filterIsOn = currentFilters.some((value) => value === filter)
						if (filterIsOn) {
							this.selectedChips.filters = currentFilters.filter(
								(item) => item !== filter
							)
						} else {
							this.selectedChips.filters = [
								...currentFilters.filter(
									(filter) =>
										!this.excludeConflictFilters(name).some(
											(item) => item === filter
										)
								),
								filter,
							]
						}
					} else {
						this.$set(this.selectedChips, 'filters', [filter])
					}
					this.applySelection()
					break
				}
				case 'myposts': {
					this.filters.myposts = !this.filters.myposts
					this.applySelection()
					break
				}
				case 'past': {
					const newValue = !this.filters.past
					this.filters.past = newValue
					this.date.option = null

					if (newValue) {
						const date = new Date()
						const year = date.getFullYear()
						const month = this.pad(date.getMonth() + 1)
						const day = this.pad(date.getDate())
						const formattedDate = year + '-' + month + '-' + day
						this.date.selectedRange = {
							from: null,
							to: formattedDate,
						}
					} else {
						this.date.selectedRange = {
							from: null,
							to: null,
						}
					}
					this.applySelection()
					break
				}
				default: {
					this.cachedChips = _.cloneDeep(this.selectedChips)
					this.cachedFilters = _.cloneDeep(this.filters)
					this.cachedDate = _.cloneDeep(this.date)
				}
			}
			if (
				name !== 'clear' &&
				!this.filterValues.some((filter) => filter.name === name) &&
				!Object.keys(this.filters).some((filter) => filter === name)
			) {
				this.filterModalIsVisible = true
			}
		},
		isButtonActive(name) {
			if (this.filterModalIsVisible && this.currentModalFilter === name) return true

			switch (name) {
				case 'clear': {
					return this.currentModalFilter === 'clear' || this.enableClearButton
				}
				case 'scheduled':
				case 'admin':
				case 'users':
				case 'register':
				case 'schedule':
				case 'categories':
				case 'follow':
				case 'event_follow':
				case 'registered': {
					const filterValue = this.filterValues.find(
						(filter) => filter.name === name
					).filter
					return (
						this.selectedChips.filters &&
						this.selectedChips.filters.some((filter) => filter === filterValue)
					)
				}
				case 'myposts': {
					return this.filters[name]
				}
				case 'category': {
					return this.filters.category_id
				}
				case 'sort': {
					return this.filters.field
				}
				case 'date': {
					return (
						(this.date.selectedRange.to || this.date.selectedRange.from) &&
						!this.filters.past
					)
				}
				case 'past': {
					return this.filters.past
				}
				default:
					return (
						(this.currentModalFilter === name && this.filterModalIsVisible) ||
						(this.selectedChips[name] && this.selectedChips[name].length)
					)
			}
		},
		excludeConflictFilters(currentFilter) {
			return this.mutuallyExclusiveFilters[currentFilter] || []
		},
		resetFilters() {
			this.filterModalIsVisible = false
			this.currentModalFilter = 'clear'
			this.currentModalLabel = null
			this.selectedChips = {}
			this.filters = {
				page: 1,
				myposts: false,
				category_id: null,
				past: false,
				field: null,
			}
			this.date = {
				selectedRange: {
					from: null,
					to: null,
				},
				option: null,
				error: '',
			}
			this.cachedChips = null
		},
		clearFilter(name) {
			switch (name) {
				case 'chapters':
				case 'tags': {
					this.selectedChips[name] = []
					break
				}
				case 'scheduled':
				case 'admin':
				case 'users':
				case 'register':
				case 'schedule':
				case 'categories':
				case 'follow':
				case 'event_follow':
				case 'registered': {
					const filterItem = this.filterValues.find((value) => value.name === name)
					this.selectedChips.filters = this.selectedChips.filters.filter(
						(filter) => filter !== filterItem.filter
					)
					break
				}
				case 'sort': {
					this.filters.field = null
					break
				}
				case 'category': {
					this.filters.category_id = null
					break
				}
				case 'date': {
					this.date = {
						selectedRange: {
							from: null,
							to: null,
						},
						option: null,
						error: '',
					}
					break
				}
				case 'past': {
					this.date.selectedRange.to = null
					this.filters.past = false
					break
				}
				case 'myposts': {
					this.filters.myposts = false
					break
				}
				default: {
					this.selectedChips[name] = []
				}
			}
			this.getFilteredItems()
		},
		closeModal() {
			this.filterModalIsVisible = false

			this.selectedChips = _.cloneDeep(this.cachedChips)
			this.filters = _.cloneDeep(this.cachedFilters)
			this.date = _.cloneDeep(this.cachedDate)
			this.cachedChips = null
			this.cachedFilters = null
			this.cachedDate = null

			if (this.enableClearButton) {
				this.currentModalFilter = 'clear'
			}
		},
		applySelection() {
			switch (this.currentModalFilter) {
				case 'sort': {
					if (this.filters.field !== this.cachedFilters.field) {
						if (this.filterModalIsVisible) {
							this.toggleFilterModalIsVisible()
						}
						this.getFilteredItems()
					}
					break
				}
				case 'category': {
					if (this.filters.category_id !== this.cachedFilters.category_id) {
						if (this.filterModalIsVisible) {
							this.toggleFilterModalIsVisible()
						}
						this.getFilteredItems()
					}
					break
				}
				case 'date': {
					if (!this.cachedDate || !_.isEqual(this.date.selectedRange, this.cachedDate)) {
						if (this.filterModalIsVisible) {
							this.toggleFilterModalIsVisible()
						}
						this.filters.past = false
						this.getFilteredItems()
					}
					break
				}
				default: {
					if (this.enableClearButton) {
						this.currentModalFilter = 'clear'
					} else {
						if (!_.isEqual(this.selectedChips, this.cachedChips)) {
							this.getFilteredItems()
						}
					}
					if (this.filterModalIsVisible) {
						this.toggleFilterModalIsVisible()
					}
				}
			}
		},
		setItem(payload) {
			const { filter, item } = payload

			switch (filter) {
				case 'category': {
					this.filters.category_id = item
					break
				}
				case 'sort': {
					this.filters.field = item
					break
				}
				case 'date': {
					if (!this.isDateFilterValid(this.date.selectedRange, item)) {
						this.date.error =
							'The end date of the filter must be greater than the start date'
						this.date.option = null
						break
					} else {
						const { date, option } = item
						this.date.selectedRange = {
							from:
								option === 'clear'
									? date.from
									: date.from ?? this.date.selectedRange.from,
							to:
								option === 'clear'
									? date.to
									: date.to ?? this.date.selectedRange.to,
						}
						this.date.option = option ?? null
						break
					}
				}
				default: {
					if (!this.selectedChips[filter]) {
						this.$set(this.selectedChips, filter, [item])
					} else if (this.selectedChips[filter].some((chip) => chip === item)) {
						this.selectedChips[filter] = this.selectedChips[filter].filter(
							(chip) => chip !== item
						)
					} else {
						this.selectedChips[filter] = [...this.selectedChips[filter], item]
					}
				}
			}
		},
		isDateFilterValid(currentDateRange, dateValue) {
			const { date, time, type } = dateValue
			const { from, to } = currentDateRange || {}

			const isThisEndDateForFullRange = from && type === 'to'
			const isThisStartDateForFullRange = to && type === 'from'

			if (isThisEndDateForFullRange) {
				const fromTimestamp = Math.floor(new Date(currentDateRange.from).getTime() / 1000)
				const toTimestamp = Math.floor(new Date(`${date} ${time}`).getTime() / 1000)

				return toTimestamp > fromTimestamp
			}

			if (isThisStartDateForFullRange) {
				const fromTimestamp = Math.floor(new Date(`${date} ${time}`).getTime() / 1000)
				const toTimestamp = Math.floor(new Date(currentDateRange.to).getTime() / 1000)

				return fromTimestamp < toTimestamp
			}

			return true
		},
		pad(number) {
			return (number < 10 ? '0' : '') + number
		},
		cacheCurrentFilters(value) {
			let routeName = null
			switch (this.$route.name) {
				case 'directory':
				case 'threads': {
					routeName = `${this.$route.name}_${value}`
					break
				}

				case 'event-agenda':
				case 'my-agenda-events': {
					routeName = `${this.agendaName}_${value}`
					break
				}
				default: {
					routeName = this.$route.name
				}
			}
			this.cachePageFilters({
				name: routeName,
				filters: {
					currentModalFilter: this.currentModalFilter,
					selectedChips: this.selectedChips,
					filters: this.filters,
					date: this.date,
				},
			})
		},
		setCachedFilters(value) {
			let routeName = null
			switch (this.$route.name) {
				case 'directory':
				case 'threads':
				case 'event-agenda':
				case 'my-agenda-events': {
					routeName = `${this.$route.name}_${value}`
					break
				}
				default: {
					routeName = this.$route.name
				}
			}

			if (this.cachedPageFilters[routeName]) {
				const { currentModalFilter, date, filters, selectedChips } =
					this.cachedPageFilters[routeName]
				this.currentModalFilter = currentModalFilter
				this.date = date
				this.filters = filters
				this.selectedChips = selectedChips
			}
		},
		getFilteredItems() {
			switch (this.$route.name) {
				case 'event-links-by-id': {
					this.getActionLinks(this.requestQuery)
					break
				}
				case 'sub-directory-by-id': {
					this.getSubDirectories(this.requestQuery)
					break
				}
				case 'event-actions-by-id': {
					this.getActionFiles(this.requestQuery)
					break
				}
				case 'polls-users': {
					this.getPollUsers(this.requestQuery)
					break
				}
				case 'event-speakers': {
					this.getEventSpeakersById(this.requestQuery)
					break
				}
				case 'exhibitor-staff': {
					this.getBoothStaff(this.requestQuery)
					break
				}
				case 'partners': {
					this.fetchPartners(this.requestQuery)
					break
				}
				case 'threads': {
					this.fetchPosts(this.requestQuery)
					break
				}
				case 'events': {
					this.fetchEvents(this.requestQuery)
					break
				}
				case 'forums': {
					this.fetchForumCategories(this.requestQuery)
					break
				}
				case 'attendees':
				case 'users': {
					this.getAttendeesEvent(this.requestQuery)
					break
				}
				case 'directory': {
					this.getDirectories(this.requestQuery)
					break
				}
				case 'resources': {
					this.getResources(this.requestQuery)
					break
				}
				case 'resource': {
					this.getResourcesById(this.requestQuery)
					break
				}
				case 'event-agenda':
				case 'my-agenda-events': {
					this.getAgendaEvent(this.requestQuery)
					break
				}
				case 'forums-by-category-id': {
					this.fetchForums(this.requestQuery)
					break
				}
			}
		},
		onPageChange(page) {
			this.filters.page = page
			window.scrollTo(0, 0)
			this.getFilteredItems()
		},
	},
	computed: {
		...mapGetters('settings', ['appCore', 'user', 'eventSettings']),
		...mapGetters('event', ['eventTracks', 'attendees']),
		...mapGetters('auth', ['profile']),
		...mapGetters('tag', ['tags', 'isTagsLoading', 'tagsMeta']),
		...mapGetters('list', ['listsMeta']),
		...mapGetters('app', ['cachedPageFilters', 'search', 'sortLists']),
		chipsList() {
			const routeName = this.$route.name === 'resource' ? 'resources' : this.$route.name
			const routeQuery =
				this.$route.name === 'resource'
					? { advance: this.$route.query.advance }
					: this.$route.query

			if (!this.appCore) {
				return []
			}
			if (this.chipsFromAppCore.some((chip) => chip === routeName)) {
				const { chips = [] } =
					this.appCore.appMenuNormalized.baseMenuItems.find((item) => {
						const {
							route: { query: queryCurrentObjectParams },
						} = item
						const queryCurrentParams = _.mapValues(routeQuery, (value) => String(value))
						const planeQueryCurrentObjectParams = _.mapValues(
							queryCurrentObjectParams,
							(value) => String(value)
						)
						return _.isEqual(queryCurrentParams, planeQueryCurrentObjectParams)
					}) || {}
				if (['threads', 'resources', 'resource'].includes(this.$route.name)) {
					if (!chips) {
						return [{ name: 'sort' }]
					}
					return [...chips, { name: 'sort' }]
				}
				return chips
			} else {
				switch (routeName) {
					case 'events': {
						return this.eventSettings
							? [
									...this.eventSettings.normalizedChips,
									{ name: 'sort', content: 'Sort by' },
							  ]
							: [{ name: 'sort', content: 'Sort by' }]
					}
					case 'event-agenda':
					case 'my-agenda-events': {
						if (!this.eventSettings) {
							return [{ name: 'sort', content: 'Sort by' }]
						}
						const filter_name = this.isMyAgendaPage
							? this.eventSettings.my_agenda_filter_name
							: this.eventSettings.agenda_filter_name

						const filter = this.isMyAgendaPage
							? this.eventSettings.my_agenda_filter
							: this.eventSettings.agenda_filter

						if (!filter_name || !filter) {
							return []
						}
						const filterNames = filter_name.split(',')
						const filterContent = filter.split(',')

						const chips = filterNames.map((name, index) => {
							return { name: name, content: filterContent[index] }
						})
						return [...chips, { name: 'sort', content: 'Sort by' }]
					}
					case 'users': {
						return !this.user || !Array.isArray(this.user.normalizedChips)
							? [{ name: 'sort', content: 'Sort by' }]
							: [...this.user.normalizedChips, { name: 'sort', content: 'Sort by' }]
					}
					case 'attendees': {
						if (
							!this.eventSettings ||
							!this.eventSettings.attendee_filter ||
							!this.eventSettings.attendee_filter_name
						) {
							return [{ name: 'sort', content: 'Sort by' }]
						}
						const filterNames = this.eventSettings.attendee_filter.split(',')
						const filterContent = this.eventSettings.attendee_filter_name.split(',')

						const chips = filterNames.map((name, index) => {
							return { name: name, content: filterContent[index] }
						})
						return [...chips, { name: 'sort', content: 'Sort by' }]
					}
					case 'exhibitor-staff': {
						return [{ name: 'sort', content: 'Sort by' }]
					}
					case 'partners': {
						if (
							!this.eventSettings ||
							!this.eventSettings.exhibitors_filter ||
							!this.eventSettings.exhibitors_filter_name
						) {
							return [{ name: 'sort', content: 'Sort by' }]
						}
						const filterNames = this.eventSettings.exhibitors_filter.split(',')
						const filterContent = this.eventSettings.exhibitors_filter_name.split(',')
						const chips = filterNames.map((name, index) => {
							return { name: name, content: filterContent[index] }
						})
						return [...chips, { name: 'sort', content: 'Sort by' }]
					}
					case 'event-speakers': {
						return [
							{
								name: 'clear',
								content: 'All',
							},
							{ name: 'sort', content: 'Sort by' },
							{
								name: 'chapters',
								content: 'My Groups',
							},
						]
					}
					case 'forums-by-category-id': {
						return [{ name: 'sort' }]
					}
					case 'forums': {
						return [
							{
								name: 'clear',
								content: 'All',
							},
							{
								name: 'categories',
								content: 'My Categories',
							},
							{
								name: 'chapters',
								content: 'My Groups',
							},
						]
					}
					case 'polls-users': {
						return [
							{
								name: 'clear',
								content: 'All',
							},
							{
								name: 'options',
								content: 'Options',
							},
							{
								name: 'sort',
							},
						]
					}
					default:
						return []
				}
			}
		},
		isFiltersEmpty() {
			const values = Object.values(this.selectedChips)
			return !values.some((array) => array.length)
		},
		enableClearButton() {
			return (
				this.isFiltersEmpty &&
				!this.filterModalIsVisible &&
				!this.filters.category_id &&
				!this.filters.field &&
				!this.date.selectedRange.to &&
				!this.date.selectedRange.from &&
				!this.filters.past &&
				!this.filters.myposts
			)
		},
		userId() {
			return this.profile && this.profile.user_id
		},
		initQuery() {
			const pageQuery = `?page=${this.filters.page}`
			switch (this.$route.name) {
				case 'sub-directory-by-id': {
					return (
						pageQuery +
						`&category_id=${this.$route.query.category_id}&directory_parent_id=${this.$route.params.id}&expand=public`
					)
				}
				case 'event-links-by-id': {
					return pageQuery + `&action_id=${this.$route.params.actionId}`
				}
				case 'event-actions-by-id': {
					return pageQuery + `&action_id=${this.$route.params.actionId}`
				}
				case 'users': {
					if (this.isButtonActive('sort')) {
						return pageQuery
					}
					return pageQuery + `&sort=user_lname`
				}
				case 'polls-users': {
					return pageQuery + `&id=${this.$route.query.thread_id}&expand=poll_answer`
				}

				case 'forums-by-category-id': {
					if (this.isButtonActive('sort')) {
						return pageQuery + `&category_id=${this.$route.params.id}`
					} else {
						return (
							pageQuery +
							`&category_id=${this.$route.params.id}&sort=-update_timestamp`
						)
					}
				}
				case 'event-speakers': {
					if (this.isButtonActive('sort')) {
						return pageQuery + `&event_id=${+this.$route.params.id}`
					} else {
						return pageQuery + `&event_id=${+this.$route.params.id}&sort=speaker_name`
					}
				}
				case 'partners': {
					return pageQuery + `&group_id=${this.$route.params.id}`
				}
				case 'exhibitor-staff': {
					if (this.isButtonActive('sort')) {
						return `page=${this.filters.page}&partner_id=${this.$route.params.id}`
					} else {
						return `page=${this.filters.page}&partner_id=${this.$route.params.id}&sort=user_lname`
					}
				}
				case 'attendees': {
					const eventIdParam = `&event_id=${this.$route.params.id}`
					if (this.isButtonActive('event_follow') && this.isButtonActive('sort')) {
						return pageQuery + eventIdParam
					}
					if (this.isButtonActive('event_follow')) {
						return pageQuery + eventIdParam + '&sort=user_lname'
					}
					if (this.isButtonActive('sort')) {
						return pageQuery + eventIdParam + '&filter=event'
					}
					return pageQuery + eventIdParam + '&filter=event&sort=user_lname'
				}
				case 'threads': {
					if (this.isButtonActive('sort')) {
						return pageQuery + `&thread_menu_id=${this.$route.query.thread_menu_id}`
					} else {
						return (
							pageQuery +
							`&thread_menu_id=${this.$route.query.thread_menu_id}&sort=-thread_time_order`
						)
					}
				}
				case 'events': {
					if (this.isButtonActive('sort')) {
						return pageQuery
					} else {
						return pageQuery + `&sort=event_order`
					}
				}
				case 'forums': {
					return pageQuery + `&expand=lastActiveForum`
				}
				case 'directory': {
					return pageQuery + `&category_id=${this.$route.query.category_id}&expand=public`
				}
				case 'resources': {
					if (this.isButtonActive('sort')) {
						return pageQuery
					}
					return pageQuery + `&sort=resources_name`
				}
				case 'resource': {
					if (this.isButtonActive('sort')) {
						return pageQuery + `&parentId=${this.$route.params.id}`
					} else {
						return pageQuery + `&parentId=${this.$route.params.id}&sort=resources_name`
					}
				}
				case 'event-agenda':
				case 'my-agenda-events': {
					const sortField = '&sort=events_agenda_order'
					const eventId = `&event_id=${this.$route.params.id}`
					const agendaInitFilter =
						!this.filters.past &&
						!this.date.selectedRange.from &&
						!this.date.selectedRange.to
							? `&from_timestamp=${Math.floor(Date.now() / 1000)}`
							: ''

					const isMyAgendaRoute = this.$route.name === 'my-agenda-events'
					const isSorted = this.isButtonActive('sort')
					let myAgendaInitFilter = ''
					if (isMyAgendaRoute) {
						myAgendaInitFilter =
							this.isButtonActive('registered') || this.isButtonActive('scheduled')
								? ''
								: '&filter=schedregist'
					}
					const baseQuery = pageQuery + eventId + agendaInitFilter + myAgendaInitFilter
					return isSorted ? baseQuery : baseQuery + sortField
				}
				default: {
					return pageQuery
				}
			}
		},
		requestQuery() {
			const keys = Object.keys(this.selectedChips)
			const values = Object.values(this.selectedChips)

			const initQuery = this.initQuery
			let query = initQuery

			keys.forEach((key, keyIndex) => {
				switch (key) {
					case 'options': {
						values[keyIndex].forEach((value) => {
							query += `&poll_answer_ids[]=${value}`
						})
						break
					}
					case 'author': {
						values[keyIndex].forEach((value) => {
							query += `&resource_author[]=${value}`
						})
						break
					}
					case 'chapters': {
						values[keyIndex].forEach((value) => {
							query += `&chapter_id[]=${value}`
						})
						break
					}
					case 'tags': {
						values[keyIndex].forEach((value) => {
							query += `&tag_ids[]=${value}`
						})
						break
					}
					case 'filters': {
						values[keyIndex].forEach((value) => {
							query += `&filter=${value}`
						})
						break
					}
					case 'tracks': {
						values[keyIndex].forEach((value) => {
							query += `&tracks_id[]=${value}`
						})
						break
					}
					case 'type': {
						values[keyIndex].forEach((value) => {
							query += `&resource_type[]=${value}`
						})
						break
					}
					default: {
						values[keyIndex].forEach((value) => {
							query += `&${key}[]=${value}`
						})
					}
				}
			})

			Object.keys(this.filters).forEach((key) => {
				switch (key) {
					case 'myposts': {
						if (this.filters.myposts) {
							query += `&user_id=${this.userId}`
						}
					}
				}
			})

			if (this.filters.category_id) {
				query += `&category_id=${this.filters.category_id}`
			}
			if (this.filters.field) {
				query += `&sort=${this.filters.field}`
			}

			if (this.date.selectedRange.to) {
				query += `&to_timestamp=${
					Math.floor(new Date(this.date.selectedRange.to).getTime()) / 1000
				}`
			}

			if (this.date.selectedRange.from) {
				query += `&from_timestamp=${
					Math.floor(new Date(this.date.selectedRange.from).getTime()) / 1000
				}`
			}

			if (this.search) {
				query += `&search=${this.search}`
			}

			return query
		},
		cachedFiltersKey() {
			let key = null
			switch (this.$route.name) {
				case 'threads': {
					key = this.$route.query.thread_menu_id
					break
				}
				case 'directory': {
					key = this.$route.query.category_id
					break
				}
				case 'attendees':
				case 'event-agenda':
				case 'my-agenda-events': {
					key = this.$route.params.id
				}
			}
			return key
		},
	},
	watch: {
		search() {
			clearTimeout(this.timer)

			this.filters.page = 1
			this.timer = setTimeout(() => {
				this.getFilteredItems()
			}, DEBOUNCE_TIMEOUT)
		},
		'$route.query.thread_menu_id': {
			handler(newValue, oldValue) {
				this.cacheCurrentFilters(+oldValue)
				this.resetFilters()
				this.setCachedFilters(+newValue)
			},
		},
		'$route.query.category_id': {
			handler(newValue, oldValue) {
				this.cacheCurrentFilters(oldValue)
				this.resetFilters()
				this.setCachedFilters(newValue)
			},
		},
	},
	created() {
		if (!this.listsMeta.length) {
			this.getListsMeta()
		}

		this.setCachedFilters(this.cachedFiltersKey)
	},
	beforeRouteLeave(to, from, next) {
		this.cacheCurrentFilters(this.cachedFiltersKey)
		this.resetFilters()
		next()
	},
	data() {
		return {
			filterModalIsVisible: false,
			currentModalFilter: 'clear',
			currentModalLabel: null,
			selectedChips: {},
			filters: {
				page: 1,
				myposts: false,
				category_id: null,
				past: false,
				field: null,
			},
			date: {
				selectedRange: {
					from: null,
					to: null,
				},
				option: null,
				error: '',
			},
			cachedChips: null,
			cachedDate: null,
			cachedFilters: null,
			timer: 0,
			chipsFromAppCore: ['threads', 'directory', 'resources'],
			filterValues: [
				{ name: 'admin', filter: 'admin-news' },
				{ name: 'users', filter: 'user-news' },
				{ name: 'register', filter: 'follow' },
				{ name: 'schedule', filter: 'schedule' },
				{ name: 'categories', filter: 'follow' },
				{ name: 'follow', filter: 'follow' },
				{ name: 'registered', filter: 'registered' },
				{ name: 'scheduled', filter: 'scheduled' },
				{ name: 'event_follow', filter: 'event_follow' },
			],
			mutuallyExclusiveFilters: {
				scheduled: ['registered'],
				registered: ['scheduled'],
				follow: ['schedule', 'schedregist'],
				schedule: ['follow', 'schedregist'],
				schedregist: ['follow', 'schedule'],
			},
		}
	},
}
